module.exports = __webpack_public_path__ + "static/media/name-min.196599ed.png";